import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addNewCompanyData,
  deleteCompany,
  fetchCompanyList,
  updateCompany,
} from "../thunks/companyListThunks";

import type { CompanyList } from "../../utils/types/companyList";

interface CompanyListState {
  companyList: CompanyList[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}

const initialState: CompanyListState = {
  companyList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const companyListSlice = createSlice({
  name: "companyList",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyList.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;

      })
      .addCase(fetchCompanyList.fulfilled, (state, action) => {
        state.companyList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchCompanyList.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });

    builder
      .addCase(updateCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companyList = state.companyList.map((company) => {
          if (company.companyId === action.payload?.companyId) {
            return { ...company, ...action.payload };
          }
          return company;
        });
      })
      .addCase(updateCompany.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deleteCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companyList = state.companyList.filter(
          (company) => company.companyId !== action.payload?.id
        );
      })
      .addCase(deleteCompany.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewCompanyData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewCompanyData.fulfilled, (state, action) => {
        state.loading = false;
        state.companyList = [action.payload, ...state.companyList];
      })
      .addCase(addNewCompanyData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    addWebSocketCases(builder, "companyList", "companyList");
  },
});

export const { resetDataFetched } = companyListSlice.actions;
export default companyListSlice.reducer;
